var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      staticClass: "travel-service-chips text-center my-1",
      attrs: { color: _vm.color, outlined: "" }
    },
    [
      _c("v-icon", { staticClass: "small mr-1 my-1" }, [
        _vm._v(_vm._s(_vm.icon))
      ]),
      _c("span", [_vm._v(_vm._s(_vm.text))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }